import type { HTMLAttributes } from 'react';
import { cn } from '../../lib/cn';

interface CardProps extends HTMLAttributes<HTMLElement> {
  as?: 'div' | 'section' | 'form' | 'article';
  padded?: boolean;
  /** Lifted panel with a soft shadow, e.g. the first row that overlaps the page band. */
  raised?: boolean;
}

/** The white panel content sits on. */
export function Card({ as: Tag = 'div', padded = false, raised = false, className, ...rest }: CardProps) {
  return (
    <Tag
      className={cn(
        'min-w-0 rounded-xl bg-surface',
        raised ? 'shadow-raised' : 'border border-line',
        padded && 'px-6 py-5',
        className,
      )}
      {...(rest as HTMLAttributes<HTMLElement>)}
    />
  );
}
